var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layer',{ref:"layer"},[_c('v-line',{attrs:{"config":{
      points: [_vm.cursor.x || 0, 0, _vm.cursor.x || 0, _vm.ch],
      stroke: _vm.cursor.color,
      strokeWidth: 1,
      lineCap: 'round',
      lineJoin: 'round',
      dash: [2, 5]
    }}}),_c('v-line',{attrs:{"config":{
      points: [0, _vm.cursor.y || 0, _vm.cw, _vm.cursor.y || 0],
      stroke: _vm.cursor.color,
      strokeWidth: 1,
      lineCap: 'round',
      lineJoin: 'round',
      dash: [2, 5]
    }}}),(_vm.mode == 'circ' || _vm.mode == 'ruler')?_c('v-circle',{attrs:{"config":{
      x: _vm.cursor.x || 0,
      y: _vm.cursor.y || 0,
      stroke: 'white',
      strokeWidth: 1,
      radius: 5,
      fill: _vm.cursor.color
    }},on:{"dblclick":function($event){return _vm.$emit('dblclick', $event)}}}):_vm._e(),(_vm.mode == 'rect')?_c('v-rect',{attrs:{"config":{
      stroke: _vm.cursor.color,
      x: _vm.cursor.x - _vm.cw / 5 / 2 || 0,
      y: _vm.cursor.y - _vm.ch / 5 / 2 || 0,
      width: _vm.cw / 5,
      height: _vm.ch / 5
    }},on:{"dblclick":function($event){return _vm.$emit('dblclick', $event)}}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }